import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LANGSMITH_FETCH_PETITION_CONTENT = defineFcm('langsmith_fetch_petition_content')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			shape: { type: 'boolean' },
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'squad-data-ai-enablement',
		scope: 'llm-prompt-executor-service',
		context: 'LangSmith prompt petition content fetch',
		description:
			'Per-prompt toggle (keyed by LangSmith prompt/classifier name, e.g. "ppo-update-classifier") controlling whether llm_prompt_executor fetches full petition content before invoking that prompt.',
		template: { 'ppo-update-classifier': true },
	});
